var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "48px",
    viewBox: "0 0 85 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EmptyState@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-1187.000000, -1264.000000)",
    fill: "#031F42",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(254.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Copy-3",
    transform: "translate(674.000000, 1048.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.505832,152.334572 C296.136797,153.762082 296.948038,155.100372 297.849417,156.349442 L286.492047,167.501859 L275.314952,156.527881 L262.154825,169.553903 L259,166.342007 L275.40509,150.104089 L286.492047,161.256506 L295.505832,152.334572 Z M275.314952,143.144981 L286.492047,154.118959 L293.793213,146.892193 C293.432662,145.286245 293.252386,143.680297 293.252386,141.98513 C293.252386,141.628253 293.252386,141.360595 293.252386,141.003717 L286.492047,147.873606 L275.314952,136.810409 L259,152.959108 L262.154825,156.081784 L275.314952,143.144981 Z M344,166.877323 L340.845175,170 L329.397667,158.669145 C326.152704,160.810409 322.276776,162.148699 318.040297,162.148699 C306.863203,162.148699 297.759279,153.137546 297.759279,142.074349 C297.759279,131.011152 306.863203,122 318.040297,122 C329.217391,122 338.321315,131.011152 338.321315,142.074349 C338.321315,147.33829 336.248144,152.245353 332.822906,155.814126 L344,166.877323 Z M333.90456,142.074349 C333.90456,133.420074 326.783669,126.371747 318.040297,126.371747 C309.296925,126.371747 302.176034,133.420074 302.176034,142.074349 C302.176034,150.728625 309.296925,157.776952 318.040297,157.776952 C326.783669,157.776952 333.90456,150.728625 333.90456,142.074349 Z M315.78685,146.713755 L320.293743,146.713755 L320.293743,131.100372 L315.78685,131.100372 L315.78685,146.713755 Z M318.040297,148.944238 C316.778367,148.944238 315.78685,149.925651 315.78685,151.174721 C315.78685,152.423792 316.778367,153.405204 318.040297,153.405204 C319.302227,153.405204 320.293743,152.423792 320.293743,151.174721 C320.293743,149.925651 319.302227,148.944238 318.040297,148.944238 Z",
    id: "EmptyState"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.adbcbcbc9844b4e2ac4e6e3ff0017432.svg";
export { ForwardRef as ReactComponent };